import { Component } from '@angular/core';

@Component({
  selector: 'app-refund-request',
  templateUrl: './refund-request.component.html'
})
export class RefundRequestComponent {
  requestId: string;
  constructor() {
    if (localStorage.getItem('requestId') != undefined) {
      this.requestId = localStorage.getItem('requestId');
      localStorage.removeItem('requestId');
    }
    else if (history.state.data && history.state.data.requestId) {
      this.requestId = history.state.data.requestId;
    }
  }
}
